var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { Autocomplete, Box, Stack, TextField, Typography } from "@mui/material";
import { createFilterOptions } from "@mui/material/Autocomplete";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import CustomModal from "../modal/CustomModal";
import ContactSearchApi from "../../../infrastructure/api/pages/contact-search-api";
// Links an EXISTING contact to another lead (contacts-search/link, Permission.Contacts.Create).
// Contact data is not touched — only a new LeadContact junction is created. Mirrors the
// Objects screen's LinkObjectDialog, minus the company-role step (not part of a contact link).
const LinkContactDialog = ({ open, contactId, contactName, onClose, onLinked, }) => {
    const { t: translate } = useTranslation();
    const [leadOptions, setLeadOptions] = useState([]);
    const [selectedLead, setSelectedLead] = useState(null);
    const [loadingOptions, setLoadingOptions] = useState(false);
    const [saving, setSaving] = useState(false);
    useEffect(() => {
        if (!open || !contactId)
            return;
        setSelectedLead(null);
        setLoadingOptions(true);
        ContactSearchApi.getLeadsDropdown(contactId)
            .then((res) => { var _a; return setLeadOptions((_a = res.data) !== null && _a !== void 0 ? _a : []); })
            .catch(() => toast.error(translate("Error while loading leads.")))
            .finally(() => setLoadingOptions(false));
    }, [open, contactId, translate]);
    const handleSave = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        if (!contactId || !selectedLead)
            return;
        setSaving(true);
        try {
            yield ContactSearchApi.link({ contactId, leadId: selectedLead.value });
            toast.success(translate("Contact linked successfully."));
            onLinked();
            onClose();
        }
        catch (error) {
            toast.error(((_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) || translate("Error while linking contact to lead."));
        }
        finally {
            setSaving(false);
        }
    });
    const filterLeadOptions = createFilterOptions({ limit: 50 });
    return (_jsx(CustomModal, { open: open, onClose: () => {
            if (!saving)
                onClose();
        }, size: "xs", saving: saving, handleSaveButtonClick: handleSave, heading: translate("Link contact to lead"), saveButtonText: translate("Link"), disabled: saving || !selectedLead, children: _jsxs(Stack, { spacing: 2, sx: { pt: 2, pb: 1 }, children: [contactName && contactName.trim() && contactName.trim() !== "-" && (_jsxs(Typography, { variant: "body2", noWrap: true, sx: {
                        color: "text.secondary"
                    }, children: [translate("Contact"), ": ", _jsx("b", { children: contactName.trim() })] })), _jsx(Autocomplete, { options: leadOptions, getOptionLabel: (o) => o.text, loading: loadingOptions, value: selectedLead, onChange: (_, value) => setSelectedLead(value), isOptionEqualToValue: (o, v) => o.value === v.value, filterOptions: filterLeadOptions, renderOption: (optionProps, option) => (_createElement(Box, Object.assign({ component: "li" }, optionProps, { key: option.value, sx: { minWidth: 0 } }), option.text)), renderInput: (params) => (_jsx(TextField, Object.assign({}, params, { label: translate("Lead"), fullWidth: true, slotProps: Object.assign(Object.assign({}, params.slotProps), { htmlInput: Object.assign(Object.assign({}, params.slotProps.htmlInput), { "data-testid": "lc-lead" }) }) }))) })] }) }));
};
export default LinkContactDialog;
